import { ProcessoService } from '@app/services/processo.service';
import { UsuarioTipoPermissao } from '@app/models/util/usuario-tipo-permissao';
import { ActivatedRoute, Router } from '@angular/router';

import { ModalPrazosComponent } from '@app/pages/processos/processo/shared/modal-prazos/modal-prazos';
import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { EventEmitterService } from '@app/services/event-emitter.service';
import { PrazoService } from '@app/services/prazo.service';
import { PrazoAviso } from '@app/pages/processos/processo/shared/me-avise-prazo/me-avise-prazo.model';

import { UsuarioTipoService } from '@app/services/usuario-tipo.service';

@Component({
  selector: 'app-processo',
  templateUrl: './processo.component.html',
  styleUrls: ['./processo.component.scss']
})
export class ProcessoComponent implements OnInit {

  bsModalRef: BsModalRef;
  exibirResumo: boolean;

  acessoFinanceiro: boolean;
  acessoAudiencia: boolean;
  acessoObservacao: boolean;
  acessoEntrevista: boolean;
  acessoArquivo: boolean;
  acessoDocumentos: boolean;
  acessoAnexos: boolean;

  acessoMovAdm: boolean;
  acessoMovJud: boolean;
  acessoMovEP: boolean;

  processoArquivado: boolean;
  processoId: number;
  UserPerms: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private modalService: BsModalService,
    private usuarioTipoService: UsuarioTipoService
  ) {
    this.exibirResumo = true;
  }

  ngOnInit() {
    this.route.params.subscribe(
      (params: any) => {
        let id: any = params['id'];
        if (id.includes('-e')) {
          this.exibirResumo = true;
          id = id.split('-e')[0];
        }
        this.processoId = id;
        this.processoService.verificaArquivamento(this.processoId).subscribe((arquivado) => this.processoArquivado = arquivado);
      });

      this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoFinanceiro = permissoes.find(x => x.Descricao == 'Financeiro').Selecionado;
        this.acessoAnexos = permissoes.find(x => x.Descricao == 'Anexos').Selecionado;
        this.acessoArquivo = permissoes.find(x => x.Descricao == 'Arquivo').Selecionado;
        this.acessoAudiencia = permissoes.find(x => x.Descricao == 'Audiencias').Selecionado;
        this.acessoDocumentos = permissoes.find(x => x.Descricao == 'Documentos').Selecionado;
        this.acessoEntrevista = permissoes.find(x => x.Descricao == 'Entrevistas').Selecionado;
        this.acessoObservacao = permissoes.find(x => x.Descricao == 'Observacao').Selecionado;

        this.acessoMovAdm = permissoes.find(x => x.Descricao == 'MovimentacoesAdministrativas').Selecionado;
        this.acessoMovJud = permissoes.find(x => x.Descricao == 'MovimentacoesJudiciais').Selecionado;
        this.acessoMovEP = permissoes.find(x => x.Descricao == 'MovimentacoesExecucaoProvisoria').Selecionado;
      });

  }
  
  repeated = 0;
  
  checkPermission(permissionName: string) {
    this.repeated++;
    for(let permIndex of this.UserPerms) {
      if(permIndex.Descricao == permissionName ) {
        return true;
      }
    }
    return false;
  }

  // verificaPrazo(id: number) {
  //   // this.prazoService.ObterUltimoPrazoNaoConcluido(id).subscribe((data : any) => {
  //   //   if (data != null && data.Id != 0) {
  //   //     this.abreModal(data);
  //   //   }
  //   // })
  // }

  abreModal(prazo: PrazoAviso) {
    this.modalService.config.backdrop = true;
    this.modalService.config.ignoreBackdropClick = true;
    this.modalService.config.class = 'modal-lg';
    this.bsModalRef = this.modalService.show(ModalPrazosComponent);

    this.bsModalRef.content.tipo = prazo.Tipo;
    this.bsModalRef.content.descricao = prazo.Descricao;
    this.bsModalRef.content.data = prazo.Data;

    this.bsModalRef.content.confirmar = () => {
      EventEmitterService.get('cronometro-iniciar').emit({ prazoId: prazo.Id });
    };
  }

}
